import { commonFacebookEventsUtil } from '@/shared/features/analytics/utils/facebookCommonAttributes';
import type { ProductDetail } from '../../domain/models/ProductDetail';

export interface FacebookDeliveryAvailabilityParams {
  product: ProductDetail;
  broadCity?: string | null;
  nearbyStoreAvailable?: boolean | null;
}

export function facebookDeliveryAvailabilityChecked({
  product,
  broadCity,
  nearbyStoreAvailable,
}: FacebookDeliveryAvailabilityParams): void {
  commonFacebookEventsUtil('DeliveryAvailabilityChecked', {
    content_names: product.designName ? [product.designName] : [],
    content_category: product.category ?? '',
    content_ids: [String(product.designId)],
    content_type: 'product',
    broad_city: broadCity ?? '',
    nearby_store_available:
      nearbyStoreAvailable == null ? '' : nearbyStoreAvailable ? 'true' : 'false',
    value: '',
    currency: 'INR',
  });
}
